export enum RequestStatusEnum {
    NOT_FOUND,
	PENDING,
	REQUESTED,
	OBTAINED,
	PROCESSED,
	EXPIRED
}